<template>
  <v-sheet id="js-nudges">
    <v-list two-line>
      <v-list-item v-for="nudge in nudges" :key="nudge.id" class="js-nudge">
        <v-list-item-avatar>
          <v-icon>mdi-chevron-right-circle-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <v-icon x-small v-if="nudge.sent_by_email" class="mr-2"
              >mdi-email-outline</v-icon
            >
            <v-icon x-small v-if="nudge.sent_by_text" class="mr-2"
              >mdi-message-text-outline</v-icon
            >
            {{ formatRelative(parseISO(nudge.created_at)) }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ nudge.text }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="savingNewNudge" key="savingNudge">
        <v-list-item-avatar>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-list-item-avatar>
      </v-list-item>
    </v-list>
    <v-btn
      id="js-show-nudge-form"
      @click="overlay = true"
      small
      class="secondary-action-btn"
      >nudge mentee</v-btn
    >
    <v-overlay :value="overlay">
      <v-card light max-width="850" min-width="500">
        <v-card-text>
          <v-textarea
            id="js-nudgeText"
            label="Nudge Text"
            outlined
            v-model="editableNudgeText"
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn
            id="js-submitNudge"
            @click="nudgeMentee"
            class="default-action-btn"
            >nudge</v-btn
          >
          <v-btn
            id="js-cancelNudge"
            @click="cancelNudge"
            class="cancel-action-btn"
            >cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script>
import EventBus from "@/lib/eventBus"
import formatRelative from "date-fns/formatRelative"
import parseISO from "date-fns/parseISO"

export default {
  data: function() {
    return {
      overlay: false,
      editableNudgeText: this.text,
      savingNewNudge: false
    }
  },
  props: {
    nudges: { type: Array, default: () => [] },
    menteeId: { type: Number, default: 0 },
    mentorId: { type: Number, default: 0 },
    nudgeableType: { type: String, default: "" },
    nudgeableId: { type: Number, default: 0 },
    text: { type: String, default: "please take a look" }
  },
  methods: {
    async nudgeMentee() {
      this.savingNewNudge = true
      this.overlay = false
      await this.$store.dispatch("nudges/nudge", {
        nudgeableType: this.nudgeableType,
        nudgeableId: this.nudgeableId,
        menteeId: this.menteeId,
        mentorId: this.mentorId,
        text: this.editableNudgeText
      })
      this.savingNewNudge = false
      this.$emit("nudge")
    },
    cancelNudge() {
      this.overlay = false
      this.editableNudgeText = this.text
    },
    formatRelative(date) {
      return formatRelative(date, new Date())
    },
    parseISO(dateString) {
      return parseISO(dateString)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";
</style>
